import { Component } from '@angular/core';

@Component({
  selector: 'cmqs-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
})
export class HeaderComponent {}
